module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Prelims-new-page",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("To those who’ve joined me wishing"), _c('br'), _vm._v("under the tent,"), _c('br'), _vm._v("the stars,"), _c('br'), _vm._v("and on the backs of our bikes.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("With special thanks to those"), _c('br'), _vm._v("Who helped me publish my work,"), _c('br'), _vm._v("My greatest supporters.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c609f00c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035801855_EPUB-3.vue
// module id = 66
// module chunks = 0